export default __webpack_public_path__ + "static/media/logo_light.5a401690.png";